import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const setGlobalCounter = createAction(
  `${reduxKey}.DAMZ_GLOBAL_COUNTER_SET`,
  (conversations: number, requests: number) => ({
    conversations,
    requests,
  })
);

export const refreshCounter = createAction(`${reduxKey}.DAMZ_GLOBAL_COUNTER_REFRESH`, () => ({}));

export const delayedRefreshCounter = createAction(
  `${reduxKey}.DAMZ_GLOBAL_COUNTER_DELAYED_REFRESH`,
  (delay: number) => ({ delay })
);

export const incrementGlobalCounter = createAction(
  `${reduxKey}.DAMZ_GLOBAL_COUNTER_INCREMENT`,
  (room_ids: string | string[]) => ({
    room_ids: Array.isArray(room_ids) ? room_ids : [room_ids],
  })
);

export const decrementGlobalCounter = createAction(
  `${reduxKey}.DAMZ_GLOBAL_COUNTER_DECREMENT`,
  (room_ids: string | string[]) => ({
    room_ids: Array.isArray(room_ids) ? room_ids : [room_ids],
  })
);
